import { Component, h } from 'preact';

class TcrNumberInput extends Component
{
    constructor(props)
    {
        super(props);

        this.onPaste = this.onPaste.bind(this);
        this.validateInput = this.validateInput.bind(this);
    }

    onPaste(event)
    {
        if (typeof this.props.onPaste == 'function')
        {
            return this.props.onPaste(event);
        }
    }

    validateInput(event)
    {
        let value = event.target.value;

        //replace every invalid character
        value = value.replace(/[^0-9]/g, '');

        if (this.props.maxlength > 0) value = value.substring(0, this.props.maxlength);

        this.props.onInput({
            target: {
                value: value,
                dataset: {
                    field: this.props.field
                }
            }
        });
    }

    render()
    {
        return <input type="text" value={this.props.value} data-field={this.props.field} onInput={this.validateInput} onFocus={() => this.setState({focus: true})} onBlur={() => this.setState({focus: false})} onPaste={this.onPaste} />;
    }
}

export { TcrNumberInput };